// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { Account } from '@shared/commons/cache/Account';
import { Instrument } from '@shared/commons/cache/Instrument';
export class TerceraChartTradingToolsRenderer_DataCacheDataProvider {
    constructor(storage) {
        this.Instrument = null;
        this.Account = null;
        this.storage = storage;
    }
    Dispose() {
        this.Unsubscribe();
        this.Instrument = null;
        this.Account = null;
    }
    FilterEntity(o) {
        return o != null && Instrument.IsEqualInstrument(o.Instrument, this.Instrument) && Account.IsEqualAccount(o.Account, this.Account);
    }
    IsReady() {
        return this.Instrument !== null || this.Account !== null;
    }
    Resubscribe() {
        this.Unsubscribe();
        this.Subscribe();
    }
    Subscribe() {
        DataCache.OnAddOrder.Subscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnUpdateOrder.Subscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnRemoveOrder.Subscribe(this.MultiDataCache_RemoveOrderPositionEvent, this);
        DataCache.OnAddPosition.Subscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnUpdatePosition.Subscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnRemovePosition.Subscribe(this.MultiDataCache_RemoveOrderPositionEvent, this);
        // DataCache.UpdatePositionInfoEvent += MultiDataCache_UpdatePositionInfoEvent;
        DataCache.OnAddSLOrderToPosition.Subscribe(this.BaseDataCache_AddSLOrderEvent, this);
        DataCache.OnAddTPOrderToPosition.Subscribe(this.BaseDataCache_AddTPOrderEvent, this);
        /// /BaseApplication.App.MultiDataCache.OrderStatusChangedEvent += new OnAddOrderDelegate(MultiDataCache_OrderStatusChangedEvent);
        DataCache.OnRemoveSLOrderFromPosition.Subscribe(this.BaseDataCache_RemoveSLOrderEvent, this);
        DataCache.OnRemoveTPOrderFromPosition.Subscribe(this.BaseDataCache_RemoveTPOrderEvent, this);
        DataCache.OnAddNewTradeEvent.Subscribe(this.MultiDataCache_AddNewTradeEvent, this);
        // alert
        DataCache.AlertManager.OnAlertAdded.Subscribe(this.MultiDataCache_AddNewAlertEvent, this);
        DataCache.AlertManager.OnAlertUpdated.Subscribe(this.MultiDataCache_AddNewAlertEvent, this);
        DataCache.AlertManager.OnAlertRemoved.Subscribe(this.MultiDataCache_RemoveAlertEvent, this);
    }
    Unsubscribe() {
        DataCache.OnAddOrder.UnSubscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnUpdateOrder.UnSubscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnRemoveOrder.UnSubscribe(this.MultiDataCache_RemoveOrderPositionEvent, this);
        DataCache.OnAddPosition.UnSubscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnUpdatePosition.UnSubscribe(this.MultiDataCache_AddOrderPositionEvent, this);
        DataCache.OnRemovePosition.UnSubscribe(this.MultiDataCache_RemoveOrderPositionEvent, this);
        // DataCache.UpdatePositionInfoEvent -= MultiDataCache_UpdatePositionInfoEvent;
        DataCache.OnAddSLOrderToPosition.UnSubscribe(this.BaseDataCache_AddSLOrderEvent, this);
        DataCache.OnAddTPOrderToPosition.UnSubscribe(this.BaseDataCache_AddTPOrderEvent, this);
        /// /BaseApplication.App.MultiDataCache.OrderStatusChangedEvent -= new OnAddOrderDelegate(MultiDataCache_OrderStatusChangedEvent);
        DataCache.OnRemoveSLOrderFromPosition.UnSubscribe(this.BaseDataCache_RemoveSLOrderEvent, this);
        DataCache.OnRemoveTPOrderFromPosition.UnSubscribe(this.BaseDataCache_RemoveTPOrderEvent, this);
        DataCache.OnAddNewTradeEvent.UnSubscribe(this.MultiDataCache_AddNewTradeEvent, this);
        // alert
        DataCache.AlertManager.OnAlertAdded.UnSubscribe(this.MultiDataCache_AddNewAlertEvent, this);
        DataCache.AlertManager.OnAlertUpdated.UnSubscribe(this.MultiDataCache_AddNewAlertEvent, this);
        DataCache.AlertManager.OnAlertRemoved.UnSubscribe(this.MultiDataCache_RemoveAlertEvent, this);
    }
    BaseDataCache_RemoveTPOrderEvent(order) {
        this.storage.RemoveTPOrder(order);
    }
    BaseDataCache_RemoveSLOrderEvent(order) {
        this.storage.RemoveSLOrder(order);
    }
    BaseDataCache_AddTPOrderEvent(order) {
        if (!this.FilterEntity(order)) {
            return;
        }
        this.storage.AddTPOrder(order);
    }
    BaseDataCache_AddSLOrderEvent(order) {
        if (!this.FilterEntity(order)) {
            return;
        }
        this.storage.AddSLOrder(order);
    }
    MultiDataCache_RemoveOrderPositionEvent(order) {
        this.storage.RemoveOrderPosition(order);
    }
    MultiDataCache_AddOrderPositionEvent(order) {
        if (!this.FilterEntity(order)) {
            return;
        }
        this.storage.AddOrderPosition(order);
    }
    MultiDataCache_AddNewTradeEvent(dc, trade) {
        if (!this.FilterEntity(trade)) {
            return;
        }
        this.storage.AddNewTrade(trade);
    }
    MultiDataCache_AddNewAlertEvent(alert) {
        if (!this.FilterEntity(alert)) {
            return;
        }
        this.storage.AddNewAlert(alert);
    }
    MultiDataCache_RemoveAlertEvent(alert) {
        this.storage.RemoveAlert(alert);
    }
    GetPositions() {
        return DataCache.Trading.PositionListForAccountInstrument(this.Instrument, this.Account);
    }
    GetOrders() {
        return DataCache.Trading.OrdersListForAccountInstrument(this.Instrument, this.Account, null, false); // sl/tp NOT included
    }
    GetAlerts() {
        return DataCache.AlertManager.GetFilteredAlerts(this.Instrument, this.Account);
    }
    GetTrades() {
        return DataCache.GetFilteredTrades(this.Instrument, this.Account);
    }
}
